var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Text, Box, ChatMessage } from 'pcln-design-system';
import React from 'react';
import { StyledLoadingBox } from './StyledLoadingBubble';
import { TravelBotLogoImage } from './TravelBotLogoImage';
/**
 * DialogLoading
 * Three dots loading component
 * @public
 */
export var DialogLoading = function (props) {
    var ellipsisProps = {
        width: '10px',
        height: '10px',
        borderRadius: '5px',
        bg: '#868d95',
    };
    var MessageIcon = function Icon() {
        return React.createElement(TravelBotLogoImage, null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ChatMessage, { mb: 4, Icon: MessageIcon, variation: 'initial', message: React.createElement(Box, null,
                props.streamingText &&
                    props.streamingText.split('\n').map(function (c, ci) { return (React.createElement(Text, { fontSize: 2, key: "chat-content-".concat(ci) }, c)); }),
                React.createElement(StyledLoadingBox, { mt: 1, bg: 'background.light', width: '62px', height: '32px', align: 'center', justifyContent: 'space-between' },
                    React.createElement(Box, __assign({}, ellipsisProps, { id: 'ellipses_1' })),
                    React.createElement(Box, __assign({}, ellipsisProps, { id: 'ellipses_2' })),
                    React.createElement(Box, __assign({}, ellipsisProps, { id: 'ellipses_3' })))) })));
};
//# sourceMappingURL=DialogLoading.js.map